export default "__VITE_ASSET__CU8_x3Rq__"